import React from 'react';
import { TableHead } from '@redpanda/ui';
import { Role } from '@redpanda/types';

interface BulkSelectHeaderProps {
  userRole?: Role;
  allSelected: boolean;
  onToggleAll: () => void;
  hasItems: boolean;
}

const BulkSelectHeader: React.FC<BulkSelectHeaderProps> = ({
  userRole,
  allSelected,
  onToggleAll,
  hasItems
}) => {
  if (userRole !== Role.SUPER_ADMIN && userRole !== Role.ADMIN) {
    return null;
  }

  return (
    <TableHead className="relative" style={{ width: '60px', paddingLeft: '24px', paddingRight: '12px' }}>
      <div className="flex items-center justify-center">
        <input
          type="checkbox"
          checked={hasItems && allSelected}
          onChange={onToggleAll}
          className="h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-500"
          style={{ position: 'absolute', left: '40px' }}
        />
      </div>
    </TableHead>
  );
};

export default BulkSelectHeader;